"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var AppointmentDetails_1 = require("./AppointmentDetails");
var AppointmentDetailsWrapper = function (_a) {
    var appointmentDetails = _a.appointmentDetails, configurationSourceUrl = _a.configurationSourceUrl, journeyType = _a.journeyType;
    return (<AppointmentDetails_1.default date={appointmentDetails.preferredDate} period={appointmentDetails.preferredTime} comments={appointmentDetails.comments} configurationSourceUrl={configurationSourceUrl} journeyType={journeyType}/>);
};
exports.default = AppointmentDetailsWrapper;
